"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ListingModel = {
  url: _propTypes.default.string.isRequired,
  image: _propTypes.default.shape({
    highRes: _propTypes.default.string.isRequired,
    lowRes: _propTypes.default.string
  }).isRequired,
  address: _propTypes.default.shape({
    street: _propTypes.default.string.isRequired,
    suburb: _propTypes.default.string.isRequired,
    state: _propTypes.default.string.isRequired,
    postcode: _propTypes.default.string.isRequired
  }).isRequired,
  agent: _propTypes.default.shape({
    agencyLogo: _propTypes.default.string,
    agentPhoto: _propTypes.default.string,
    agentName: _propTypes.default.string
  }).isRequired,
  newDevelopment: _propTypes.default.bool,
  propertyName: _propTypes.default.string,
  formattedPrice: _propTypes.default.string.isRequired,
  formattedBeds: _propTypes.default.string,
  formattedBaths: _propTypes.default.string,
  formattedParking: _propTypes.default.string
};
var _default = exports.default = ListingModel;